import { FC, useState } from 'react'

import { EuiFlyoutHeader, EuiFlyoutBody, EuiFlyoutFooter, EuiTitle, EuiButton, EuiFlexGroup, EuiFlexItem, EuiFormRow, EuiCheckbox } from '@elastic/eui'
import AcFlyout from 'components/AcFlyout'

export interface AIPlanBlueprintClientPreviewTabsSettings {
  showMarketAnalysis: boolean
  showPersonas: boolean
}

export interface AIPlanBlueprintClientPreviewTabsFlyoutProps {
  currentSettings: AIPlanBlueprintClientPreviewTabsSettings
  onSave: (settings: AIPlanBlueprintClientPreviewTabsSettings) => void
  onClose: () => void
  isLoading: boolean
}

const AIPlanBlueprintClientPreviewTabsFlyout: FC<AIPlanBlueprintClientPreviewTabsFlyoutProps> = ({ currentSettings, onSave, onClose, isLoading }) => {
  const [showMarketAnalysis, setShowMarketAnalysis] = useState(currentSettings.showMarketAnalysis ?? true)
  const [showPersonas, setShowPersonas] = useState(currentSettings.showPersonas ?? true)

  const handleSave = () => {
    onSave({
      showMarketAnalysis,
      showPersonas
    })
  }

  return (
    <AcFlyout onClose={onClose}>
      <EuiFlyoutHeader>
        <EuiTitle size='m'>
          <h2>Edit Client Preview Tabs</h2>
        </EuiTitle>
      </EuiFlyoutHeader>

      <EuiFlyoutBody>
        <EuiFormRow fullWidth>
          <EuiCheckbox id='showMarketAnalysis' label='Analysis & Strategy' checked={showMarketAnalysis} onChange={e => setShowMarketAnalysis(e.target.checked)} disabled={isLoading} />
        </EuiFormRow>

        <EuiFormRow fullWidth>
          <EuiCheckbox id='showPersonas' label='Personas' checked={showPersonas} onChange={e => setShowPersonas(e.target.checked)} disabled={isLoading} />
        </EuiFormRow>
      </EuiFlyoutBody>

      <EuiFlyoutFooter>
        <EuiFlexGroup justifyContent='flexStart' gutterSize='l'>
          <EuiFlexItem grow={false}>
            <EuiButton onClick={onClose} disabled={isLoading}>
              Cancel
            </EuiButton>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiButton fill onClick={handleSave} isLoading={isLoading} disabled={isLoading}>
              Save
            </EuiButton>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlyoutFooter>
    </AcFlyout>
  )
}

export default AIPlanBlueprintClientPreviewTabsFlyout
